import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import { getParsedNumber } from "../utils/Common";
import { notification, Button, Select, Spin } from "antd";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import ViewFoodModal from "../component/modals/ViewFoodModal";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import AddSetFoodMenuModal from "../component/modals/AddSetFoodMenuModal";
import CustomLoader from "../component/menu/CustomLoader";
import TextArea from "antd/es/input/TextArea";
import { CheckCircleFilled, PlusOutlined } from "@ant-design/icons";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { allowDecimalInput, allowDecimalPaste } from "../utils/numberFieldValidator";
import ImageUploadWithCropAndWebp from "../component/common/ImageUploadWithCropAndWebp";
import CustomInputNumberV2 from "../component/CustomInputNumberV2";
import FoodTaxAndDiscount from "../component/restaurants/foods/FoodTaxAndDiscount";
import CustomInputNumber from "../component/CustomInputNumber";

function SetMenuEdit() {
  const { showNotification } = useUserStore();
  const [upsertLoading, setUpsertLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [isModalOpen, setIsModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [confirmationMessage, setConfirmationMessage] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [action, setAction] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [selectedItem, setSelectedItem] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [perPage, setPerPage] = useState(5000);
  const { setMenuId } = useParams();
  const { user, restaurantId, setNetworkCall } = useUserStore();
  const [checkedItems, setCheckedItems] = useState({});
  const [isComboModalOpen, setIsComboModalOpen] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [price, setPrice] = React.useState("");
  const [discount, setDiscount] = React.useState("");
  const [discountType, setDiscountType] = React.useState("%");
  const [categoryId, setCategoryId] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [comboName, setComboName] = useState("");
  const [defaultQuantity, setDefaultQuantity] = useState("");
  const [croppedFile, setCroppedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [description, setDescription] = useState("");
  const [addOns, setAddOns] = useState([
    {
      name: "",
      price: "",
    },
  ]);
  const [comboFoods, setComboFoods] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [filter, setFilter] = useState({
    restaurantId: "",
    searchText: "",
    sortBy: "NEWEST",
    page: 1,
    perPage: perPage,
  });
  const foodIdFromEdit = searchParams.get("foodIdEdit");
  const [availableFoods, setAvailableFoods] = useState([]);

  const [isVatApplicable, setIsVatApplicable] = useState(true);
  const [isDiscountApplicable, setIsDiscountApplicable] = useState(true);
  const [isSupplementaryDutyApplicable, setIsSupplementaryDutyApplicable] = useState(false);
  const [supplementaryDuty, setSupplementaryDuty] = useState("");

  useEffect(() => {
    const fetchFoodList = async () => {
      const { user, restaurantId } = useUserStore.getState();
      let params = { restaurantId };

      const token = user.token.token;
      ApiService.FOOD_SET_MENU_LIST(params, token).then((res) => {
        if (!res || (res && res.code !== 200)) {
          return [];
        }
        const { payload } = res;
        const { records } = payload;
        setAvailableFoods(records);
      });
    };

    fetchFoodList();
  }, []);

  const openNotification = (type, message, description, placement = "topRight") => {
    api[type]({
      message,
      description,
      placement,
    });
  };

  useEffect(() => {}, [checkedItems]);

  const onClickSaveButtonInModal = (response) => {
    setCheckedItems(response);
    if (response.comboMenuFoods && response.comboMenuFoods.length > 0) {
      openNotification(constants.NOTIFICATION.INFO, "Success", "Food added for Combo Menu");
    }
    setIsModalOpen(response.showModal);
  };

  const onClickCancelButtonInModal = (items) => {
    setIsModalOpen(false);
    setIsComboModalOpen(false);
  };

  // eslint-disable-next-line no-useless-rename
  const onImageChange = ({ fileList: fileList }) => {
    if (fileList.length > 0) {
      const file = fileList[0].originFileObj;
      const reader = new FileReader();
      reader.onloadend = () => {
        setCroppedFile(reader.result);
      };
      reader.readAsDataURL(file);
    }

    setFileList(fileList);
  };

  const beforeUpload = (file) => {
    return false;
  };

  const updateOptionName = (index, val) => {
    setAddOns((previousOption) => previousOption.map((item, i) => (index === i ? { ...item, name: val } : item)));
  };

  const addMoreOption = () => {
    let param = {
      name: "",
      price: "",
    };
    setAddOns(() => [...addOns, param]);
  };

  const removeOption = (index) => {
    setAddOns(() => [...addOns.slice(0, index), ...addOns.slice(index + 1)]);
  };

  useEffect(() => {
    fetchComboFoodList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Add empty dependency array to run only once

  const fetchComboFoodList = async () => {
    const params = { restaurantId, perPage };
    try {
      const response = await ApiService.FILTER_FOOD_LIST(params, user.token.token);

      if (response?.payload?.foodItems) {
        setComboFoods(response.payload.foodItems);
      } else {
        setComboFoods([]);
      }
    } catch (error) {
      console.error("Error fetching related items:", error);
    }
  };

  const fetchSetMenuDetails = async () => {
    setNetworkCall(true);
    try {
      const res = await ApiService.GET_SET_MENU_DETAILS(setMenuId, user.token.token);

      if (res.status === "ok") {
        const data = res.payload.record;

        setCategoryId(data.category.id);
        setCategoryName(data.category.name);

        setComboName(data.name);
        setDescription(data.details);

        setPrice(data.price.amount);
        setDiscount(data.price.discount);
        setDiscountType(data.price.isDiscountInPercent ? "%" : "BDT");

        // Set initial image if it exists
        if (data.image) {
          const initialFile = {
            uid: "-1",
            name: "image.png",
            status: "done",
            // url: process.env.REACT_APP_IMAGE_BASE_URL + data.image,
            url: data.image,
          };
          setFileList([initialFile]);
        }

        // Set initial checked items based on includes array
        const initialCheckedItems = {};
        data.includes.forEach((include) => {
          initialCheckedItems[include.foodId] = {
            optionId: include.optionId,
            optionName: include.optionName,
            quantity: include.quantity,
            restaurantId: data.restaurant.id,
            name: include.foodName,
          };
        });
        setCheckedItems({ comboMenuFoods: data.includes });
        setSelectedItems(initialCheckedItems);

        setIsVatApplicable(data.isVatApplicable);
        setIsDiscountApplicable(data.isDiscountApplicable);
        setIsSupplementaryDutyApplicable(data.isSupplementaryDutyApplicable);
        setSupplementaryDuty(data.supplementaryDuty);

        // Set initial add-ons
        if (data.addOns) {
          setAddOns(data.addOns);
        }
        setNetworkCall(false);
      }
    } catch (error) {
      console.error("Error fetching related items:", error);
    } finally {
      setNetworkCall(false);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      if (setMenuId) {
        await fetchSetMenuDetails();
      }
    };

    fetchInitialData();
  }, [setMenuId]);

  useEffect(() => {
    if (addOns.length === 0) {
      setAddOns([{ name: "", price: "" }]);
    }
  }, [addOns]);

  const onConfirm = (record, action) => {
    setIsConfirmModalOpen(false);
    orderStatusChange(record, action === constants.FOOD.ACTIVE ? constants.FOOD.ACTIVE : constants.FOOD.INACTIVE);
  };

  const onNotConfirm = () => {
    setIsConfirmModalOpen(false);
  };

  const orderStatusChange = async (record, selection = "Inactive") => {
    let food = await ApiService.FOOD_STATUS_CHANGE(
      {
        restaurantId,
        foodId: record._id,
        selection,
      },
      user.token.token
    );

    if (food.code !== 200) {
      return;
    }
  };

  const onCloseViewModal = () => {
    setIsViewModalOpen(false);
  };

  const updateQuantity = (newQty, index) => {
    setCheckedItems((prevState) => {
      const updatedItems = [...prevState.comboMenuFoods];
      updatedItems[index].quantity = newQty;
      return { ...prevState, comboMenuFoods: updatedItems };
    });

    setSelectedItems((prevSelectedItems) => {
      const updatedItems = { ...prevSelectedItems };
      const foodId = Object.keys(updatedItems)[index];
      updatedItems[foodId].quantity = newQty;
      return updatedItems;
    });
  };

  const handleQuantityChange = (nameValObj) => {
    const [index, field] = nameValObj.name.split("_");
    updateQuantity(nameValObj.value, index);
  };

  const onClickComboMenu = () => {
    setIsComboModalOpen(true);
  };

  const resetComboMenu = () => {
    if (foodIdFromEdit) {
      const food = availableFoods.find((food) => food.id === foodIdFromEdit);
      navigate(`/food/edit/${food.name}/${foodIdFromEdit}`);
      return;
    }

    setCategoryName("");
    setCategoryId(null);
    setComboName("");
    setDefaultQuantity("");
    setCroppedFile(null);
    setFileList([]);
    setDescription("");
    setAddOns([{ name: "", price: "" }]);
    setCheckedItems({});
    setPrice("");
    setDiscount("");
    setDiscountType("%");
    setSelectedItems({});

    // Redirect to the food list page
    navigate("/food?menu=combo");
    
  };

  const onClickSaveComboMenu = async () => {
    const sanitizedAddOns = addOns.filter((addOn) => addOn.name || addOn.price);

    const comboMenuData = {
      restaurantId,
      categoryId,
      categoryName,
      comboName,
      defaultQuantity,
      croppedFile,
      description,
      addOns: sanitizedAddOns.length ? sanitizedAddOns : [],
      comboFoods: checkedItems.comboMenuFoods || [],
      price,
      discount,
      discountType,
    };

    if (!comboMenuData.restaurantId) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Please fill in the restaurant ID.");
      return;
    }

    if (!comboMenuData.categoryId) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Please select a category.");
      return;
    }

    if (!comboMenuData.comboName) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Please fill in the combo name.");
      return;
    }

    if (!comboMenuData.description) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Please fill in the description details.");
      return;
    }

    const includedFood = {
      includes: comboMenuData.comboFoods.map((food) => ({
        foodId: food.foodId,
        optionId: food.optionId,
        quantity: food.quantity,
      })),
    };
    /*check total quantity of selected foods*/
    if (getTotalQuantity(includedFood) < 2) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Combo foods must contain at least two item.");
      return;
    }

    for (let addOn of comboMenuData.addOns) {
      if ((addOn.name && !addOn.price) || (!addOn.name && addOn.price)) {
        openNotification(
          constants.NOTIFICATION.ERROR,
          "Error",
          "Please fill in both name and price for add-ons or leave both empty."
        );
        return;
      }
    }

    if (comboMenuData.price <= 0) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Price must be greater than zero.");
      return;
    }

    if (comboMenuData.discountType === "%" && comboMenuData.discount > 100) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Discount percentage must be less than or equal 100.");
      return;
    }

    const priceNumber = parseFloat(comboMenuData.price);
    const discountNumber = parseFloat(comboMenuData.discount);

    if (comboMenuData.discountType === "BDT" && discountNumber > priceNumber) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Discount amount can't be greater than the price.");
      return;
    }

    const formData = new FormData();

    formData.append("setMenuId", setMenuId);
    formData.append("restaurantId", comboMenuData.restaurantId);
    formData.append("categoryId", comboMenuData.categoryId);
    formData.append("name", comboMenuData.comboName);
    formData.append("details", comboMenuData.description);

    if (comboMenuData.croppedFile) {
      formData.append("image", comboMenuData.croppedFile);
    }

    formData.append("defaultQuantity", comboMenuData.defaultQuantity);

    const priceDetails = {
      amount: comboMenuData.price,
      discount: comboMenuData.discount,
      isDiscountInPercent: comboMenuData.discountType === "%" ? "YES" : "NO",
    };
    formData.append("price", JSON.stringify(priceDetails));

    formData.append("setMenuAddOn", JSON.stringify({ addOns: comboMenuData.addOns }));

    formData.append("includedFood", JSON.stringify(includedFood));

    formData.append("isVatApplicable", isVatApplicable ? "YES" : "NO");
    formData.append("isDiscountApplicable", isDiscountApplicable ? "YES" : "NO");
    formData.append(
      "isSupplementaryDutyApplicable",
      isSupplementaryDutyApplicable ? "YES" : "NO"
    );
    formData.append(
      "supplementaryDuty",
      isSupplementaryDutyApplicable ? supplementaryDuty : 0
    );

    try {
      setUpsertLoading(true);
      const response = await ApiService.ADD_SET_FOODS(formData, user.token.token);

      const isSuccess = response.code === 200;
      if (!isSuccess) {
        showNotification(response.data?.message || 'Failed to save data.')
        setUpsertLoading(false);
        return;
      }

      if (isSuccess) {
        setUpsertLoading(false);

        showNotification("Combo Menu updated successfully!", false);
        resetComboMenu();
      }
    } catch (error) {
      openNotification(constants.NOTIFICATION.ERROR, "Error", "Failed to save data.");
      setUpsertLoading(false);
    }
  };

  const deleteImage = async () => {
    try {
      if (!setMenuId) {
        setFileList([]);
        setCroppedFile(null)
        return
      }

      setUpsertLoading(false)

      // setNetworkCall(true);
      const token = user?.token?.token;
      const params = {
        context: "SET_MENU_EDIT",
        fieldName: "image",
        modelId: setMenuId,
      }

      console.log({params})
      const res = await ApiService.ADMIN_FILE_DELETE(params, token);

      if (res.code !== 200) {
        showNotification(res.data.message)
        return;
      }

      if (res.code === 200) {
        setFileList([]);
        setCroppedFile(null)
  
        showNotification("Image deleted successfully.", false)
        return;
      }
      
    } catch (error) {
      console.error("Set menu image delete ==== ", error)
      showNotification(error.message || "An unexpected error occurred.")
    } finally {
      // setNetworkCall(false);
      setUpsertLoading(false)
    }
  }

  useEffect(() => {
    setFilter({
      ...filter,
      restaurantId,
      page: currentPage,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, restaurantId]); // Add necessary dependencies

  const handleRemoveItem = (index) => {
    const updatedComboFoods = checkedItems.comboMenuFoods.filter((item, i) => i !== index);
    setCheckedItems({ ...checkedItems, comboMenuFoods: updatedComboFoods });

    setSelectedItems((prevSelectedItems) => {
      const updatedItems = { ...prevSelectedItems };
      const foodId = Object.keys(prevSelectedItems)[index];
      delete updatedItems[foodId];
      return updatedItems;
    });
  };

  const onChangeAddOnsPrice = (nameValObj) => {
    const [index, field] = nameValObj.name.split("_");
    const val = nameValObj.value;

    setAddOns((prev) => prev.map((item, i) => (i == index ? { ...item, price: val } : item)));
  };

  const handlePrice = (value) => {
    setPrice(value);
  };
  
  const handleDiscountChange = (val) => {
    if (discountType !== "%") {
      setDiscount(val);
    }

    if (discountType === "%" && parseFloat(val) <= 100) {
      setDiscount(val);
    }
  };

  const onHandleDiscountTypeChange = (val) => {
    setDiscountType(val);

    if (val === "%" && getParsedNumber(discount) > 100) {
      setDiscount("");
    }
  };

  function getTotalQuantity(items) {
    if (!Array.isArray(items.includes)) return 0;

    return items.includes.reduce((total, item) => {
      return total + (item.quantity || 0);
    }, 0);
  }
  return (
    <div className="flex flex-col">
      {contextHolder}
      <CustomLoader />
      <Header title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} currentMenuKey={"T_3_S_3"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="flex flex-row">
              <div className="flex flex-row mb-[16px] font-uregular p-[16px] w-full items-center justify-between">
                <div className="font-ubold text-xl">Edit Set Menu / Combo</div>
                <div
                  className="px-[16px] py-[8px] rounded bg-yellow text-md font-ubold cursor-pointer"
                  onClick={() => navigate("/food?menu=combo")}
                >
                  List
                </div>
              </div>
            </div>

            <div className="bg-white pt-[20px] pb-[10px]">
              <div className="bg-white pt-[10px] pb-[10px]">
                <div className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex" style={{ width: "49%" }}>
                    <input
                      value={categoryName}
                      className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px] w-full"
                      placeholder="Combo Name"
                      disabled
                    />
                    <p className="text-red-500 top-3 ml-2">*</p>
                  </div>
                  <div className="w-1/4 flex flex-col h-[105px]">
                    <ImageUploadWithCropAndWebp fileList={fileList}
                      setFileList={(files) => {
                        if (!files || files.length < 1) {
                          return
                        }

                        setCroppedFile(files[0].originFileObj)
                        setFileList(files)
                      }}
                      deleteImage={deleteImage}
                      minWidth={500}
                    />
                  </div>
                </div>

                <div className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex" style={{ width: "49%" }}>
                    <input
                      value={comboName}
                      onChange={(e) => setComboName(e.target.value)}
                      className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px] w-full"
                      placeholder="Combo Name"
                    />
                    <p className="text-red-500 top-3 ml-2">*</p>
                  </div>
                </div>

                <div className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-[20px] pr-[25px]">
                  <div className="w-2/4 flex">
                    <TextArea
                      rows={2}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px] w-full"
                      placeholder="Max 100 words"
                    />
                    <p className="text-red-500 top-3 ml-2">*</p>
                  </div>
                  <div className="w-2/4 flex flex-col">
                    <Button
                      type="primary"
                      onClick={onClickComboMenu}
                      className="w-full mt-[16px] h-[40px] text-white border-none"
                      style={{
                        backgroundColor: "#FFD700",
                        color: "#000000",
                        fontFamily: "ubold",
                      }}
                    >
                      Update Food List <p className="text-red-500 top-3 ml-2">*</p>
                    </Button>

                    <AddSetFoodMenuModal
                      openModal={isComboModalOpen}
                      records={{
                        onFinish: onClickSaveButtonInModal,
                        onCancel: onClickCancelButtonInModal,
                        comboFoods: comboFoods,
                      }}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
                    />
                  </div>
                </div>

                {checkedItems.comboMenuFoods && checkedItems.comboMenuFoods.length > 0 && (
                  <div className="flex items-center pl-[25px] pb-[20px] pr-[25px]">
                    <span className="mr-4">Combo Items</span>
                    <div className="flex-grow h-px bg-gray-300"></div>
                  </div>
                )}
                <div className="pl-[25px] pr-[25px]">
                  {checkedItems.comboMenuFoods?.map((item, index) => (
                    <div
                      className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-2 pt-2 pr-[25px] bg-gray-100 mb-2"
                      key={index}
                    >
                      <div className="w-2/4 flex items-center break-all">
                        <CheckCircleFilled
                          style={{
                            color: "#FFD700",
                            fontSize: "16px",
                            marginRight: "8px",
                          }}
                        />
                        <p className="m-0">{item.foodName}</p>
                      </div>
                      <div className="w-2/4 break-all flex flex-col">
                        <p>{item.optionName === "System Default" ? "" : item.optionName}</p>
                      </div>
                      <div className="w-[150px] flex flex-col">
                        <div className="flex items-center gap-[10px]">
                          <p className="text-sm">QTY</p>
                          <CustomInputNumber
                            name={`${index}_qty`}
                            value={item.quantity || 1}
                            setValue={handleQuantityChange}
                            min={1}
                            max={99}
                            shouldSetValueSetObj={true}
                          />
                        </div>
                      </div>
                      <div className="flex items-center justify-end">
                        <img
                          onClick={() => handleRemoveItem(index)}
                          className="w-[27px] h-[16px] cursor-pointer"
                          src="/images/remove.svg"
                          alt="Remove"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="flex items-center pl-[25px] pb-[20px] pr-[25px]">
                  <span className="mr-4">Add-Ons</span>
                  <div className="flex-grow h-px bg-gray-300"></div>
                </div>

                {addOns.map((item, index) => (
                  <div
                    className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-[20px] pr-[25px]"
                    key={index}
                  >
                    <div className="flex flex-col" style={{ width: "49%" }}>
                      <input
                        value={item.name}
                        onChange={(e) => updateOptionName(index, e.target.value)}
                        className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px]"
                        placeholder="Add-Ons"
                      />
                    </div>
                    <div className="flex flex-col" style={{ width: "45%" }}>
                      <CustomInputNumberV2
                        name={`${index}_addOnsPrice`}
                        shouldSetValueSetObj={true}
                        placeholder={"Price"}
                        addonBefore="Price"
                        value={addOns[index].price}
                        setValue={onChangeAddOnsPrice}
                        isDecimalAllowed={true}
                        max={99999}
                        min={0}
                      />
                    </div>
                    <div className="flex items-center justify-center h-full">
                      {index === addOns.length - 1 ? (
                        <img
                          onClick={addMoreOption}
                          className="w-[16px] h-[16px] cursor-pointer"
                          src={"/images/plus.svg"}
                          alt="Add"
                        />
                      ) : (
                        <img
                          onClick={() => removeOption(index)}
                          className="w-[16px] h-[16px] cursor-pointer"
                          src={"/images/remove.svg"}
                          alt="Remove"
                        />
                      )}
                    </div>
                  </div>
                ))}

                <div className="flex items-center pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex-grow h-px bg-gray-300"></div>
                </div>

                <div className="flex flex-col pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex w-full">
                    <div className="flex ml-auto" style={{ width: "49%" }}>
                      <CustomInputNumberV2
                        placeholder={"Set Menu Price"}
                        addonBefore="Set Menu Price"
                        value={price}
                        setValue={handlePrice}
                        isDecimalAllowed={true}
                        max={99999}
                        min={0}
                      />
                      <p className="text-red-500 top-3 ml-2">*</p>
                    </div>
                  </div>

                  <div className="flex w-full mt-[20px]">
                    <div className="ml-auto flex items-center gap-[10px]" style={{ width: "49%" }}>
                      <div className="flex-[7]">
                        <CustomInputNumberV2
                          placeholder={"Discount"}
                          addonBefore="Discount"
                          value={discount}
                          setValue={handleDiscountChange}
                          isDecimalAllowed={true}
                          max={99999}
                          min={0}
                        />
                      </div>

                      <div className="flex-[3]">
                        <Select
                          value={discountType}
                          onChange={(value) => onHandleDiscountTypeChange(value)}
                          options={[
                            { label: "%", value: "%" },
                            { label: "BDT", value: "BDT" },
                          ]}
                          className="w-full"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/*Food Tax And Discount*/}
                <div className="pl-[20px] pr-6">
                  <FoodTaxAndDiscount
                    records={{
                      isVatApplicable,
                      setIsVatApplicable,
                      isDiscountApplicable,
                      setIsDiscountApplicable,
                      isSupplementaryDutyApplicable,
                      setIsSupplementaryDutyApplicable,
                      supplementaryDuty,
                      setSupplementaryDuty,
                    }}
                  />
                </div>

                <div className="flex flex-col pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex w-full mt-[10px]">
                    <div className="ml-auto flex items-center gap-[10px]" style={{ width: "49%" }}>
                      <div className="flex-[5]">
                        <Button
                          type="primary"
                          onClick={resetComboMenu}
                          className="w-full mt-[16px] h-[40px] text-white border-none"
                          style={{
                            backgroundColor: "#FFD700",
                            color: "#000000",
                            fontFamily: "ubold",
                          }}
                        >
                          Cancel
                        </Button>
                      </div>

                      <div className="flex-[5]">
                        <Button
                          type="primary"
                          disabled={upsertLoading} // ✅ disables button during loading
                          onClick={onClickSaveComboMenu}
                          className="w-full mt-[16px] h-[40px] text-white border-none"
                          style={{
                            backgroundColor: "#000000",
                            color: "#FFFFFF",
                            fontFamily: "ubold",
                          }}
                        >
                          {upsertLoading ? <Spin size={"small"} /> : "Update"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ConfirmationModal
            openModal={isConfirmModalOpen}
            records={{
              onFinish: onConfirm,
              onCancel: onNotConfirm,
              action: action,
              message: confirmationMessage,
              param: selectedItem,
            }}
          />
          <ViewFoodModal
            openModal={isViewModalOpen}
            records={{
              onFinish: onCloseViewModal,
              onCancel: onCloseViewModal,
              param: selectedItem,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default SetMenuEdit;
